module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.participants.length > 0) ? _c('div', [_c('notifications', {
    attrs: {
      "show": ['participant']
    }
  }), _vm._v(" "), _vm._l((_vm.participants), function(participant) {
    return (participant) ? _c('participant-block', {
      key: participant.id,
      attrs: {
        "alert": _vm.alerts.indexOf(participant.id) > -1,
        "participant": participant
      },
      on: {
        "removed": _vm.refresh,
        "alert": function($event) {
          _vm.alert = true
        }
      }
    }) : _vm._e()
  })], 2) : (_vm.loading) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-5x dark"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ef5bcc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Children/Children.vue
// module id = 183
// module chunks = 0